// Hardcoded kill switch for the formula-injection export sanitization fix.
// Flip to false to revert every export call site on this branch to its
// original, unsanitized behavior without touching any call site.
const EXPORT_SANITIZATION_ENABLED = true;

// Neutralizes CSV/Excel formula injection by prefixing a leading single
// quote to any string cell that begins with a formula-trigger character
// (=, +, -, @, TAB, CR), forcing spreadsheet apps to treat it as text.
export function sanitizeCellValue(value) {
  if (!EXPORT_SANITIZATION_ENABLED) return value;
  if (typeof value !== "string" || value.length === 0) return value;
  if (/^[=+\-@\t\r]/.test(value)) {
    return "'" + value;
  }
  return value;
}

export function sanitizeRow(row) {
  if (!EXPORT_SANITIZATION_ENABLED) return row;
  if (!row || typeof row !== "object") return row;
  const out = Array.isArray(row) ? [] : {};
  for (const key of Object.keys(row)) {
    const val = row[key];
    if (typeof val === "string") {
      out[key] = sanitizeCellValue(val);
    } else if (Array.isArray(val)) {
      out[key] = val.map((v) => (typeof v === "string" ? sanitizeCellValue(v) : v));
    } else {
      out[key] = val;
    }
  }
  return out;
}

export function sanitizeRows(rows) {
  if (!EXPORT_SANITIZATION_ENABLED) return rows;
  if (!Array.isArray(rows)) return rows;
  return rows.map(sanitizeRow);
}
